import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useAnalytics } from "use-analytics";
import MonospacedText from "~/client/components/MonospacedText";
import PageContent from "~/client/components/PageContent";
import PageHeading from "~/client/components/PageHeading";
import { useUserContext } from "~/client/contexts/UserContext";
import { Paragraph, Section, SectionHeading } from "./styled";
const SettingsPage = () => {
    const analytics = useAnalytics();
    useEffect(() => {
        analytics.page({ title: "Settings" });
    }, [analytics]);
    const { userId } = useUserContext();
    return (_jsxs(PageContent, { children: [_jsx(PageHeading, { children: "Settings" }), _jsxs(Section, { children: [_jsx(SectionHeading, { children: "User ID" }), _jsxs("div", { children: ["Your user ID: ", _jsx(MonospacedText, { children: userId })] }), _jsx(Paragraph, { children: "Your user ID is a randomly assigned unique identifier that is sent along with user interaction analytics in order to understand how people use this site and the Tiny Recipe Clipper extension. Your user ID is also sent with automatic error reports in order to help us diagnose and fix bugs." })] })] }));
};
export default SettingsPage;
